// Donation banner removed for Bloomteq
export const DonationBanner = () => null;
